/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateConsumerCustomerResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateConsumerCustomerCommand, serializeCreateConsumerCustomerResult, type CreateConsumerCustomerCommand, type CreateConsumerCustomerResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type WithContractRequestBuilder, WithContractRequestBuilderRequestsMetadata } from './withContract/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/consumer
 */
export interface ConsumerRequestBuilder extends BaseRequestBuilder<ConsumerRequestBuilder> {
    /**
     * The withContract property
     */
    get withContract(): WithContractRequestBuilder;
    /**
     * CreateConsumerCustomer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateConsumerCustomerResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateConsumerCustomerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateConsumerCustomerResult | undefined>;
    /**
     * CreateConsumerCustomer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateConsumerCustomerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ConsumerRequestBuilderUriTemplate = "{+baseurl}/customers/consumer";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConsumerRequestBuilderNavigationMetadata: Record<Exclude<keyof ConsumerRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    withContract: {
        requestsMetadata: WithContractRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ConsumerRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ConsumerRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateConsumerCustomerResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateConsumerCustomerCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
